import React from "react";

// bonusRefund: an edit's own bonus restore (api applyFolioEdit); otherwise pro-rata, as api splitFolioRefund.
export const computeFolioReturn = (refundAmount, folioTenderAmount, refundableAmount, bonusRemaining = 0, bonusRefund) => {
  if (refundableAmount <= 0 || folioTenderAmount <= 0) return 0;
  const amount = Math.min(Number(refundAmount), refundableAmount);
  const fraction = amount / refundableAmount;
  const card = Number((fraction * (refundableAmount - folioTenderAmount + bonusRemaining)).toFixed(2));
  return Number((amount - card + (bonusRefund ?? Number((fraction * bonusRemaining).toFixed(2)))).toFixed(2));
};

const FolioReturnNote = ({ amount }) =>
  amount > 0 ? (
    <div className="row"><div className="col-12 mt-2">{`$${amount.toFixed(2)} returns to the customer's Flower Folio balance, including the restored bonus.`}</div></div>
  ) : null;

export default FolioReturnNote;
